import { render } from "./DateSingle.vue?vue&type=template&id=6863d88c"
import script from "./DateSingle.vue?vue&type=script&lang=js"
export * from "./DateSingle.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Express\\北方\\Agent_SYSTEM\\AgentWeb\\Vue\\agentweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__